// extracted by mini-css-extract-plugin
module.exports = {"slider":"rangeSlider_slider__2ezyY"};